module.exports = __webpack_public_path__ + "static/media/grenobleLogo.efb269bb.png";